<div class="row align-center gap-8 w100 space-between">
  <div class="row gap-8 align-center">
    <rr-icon name="flag" class="award" *ngIf="pin.prio === true"></rr-icon>
    <span class="strong">{{ pin?.topic }}</span>
  </div>
  <div class="menue">
    <rr-icon
      name="more-vertical"
      class="pointer"
      (click)="openMenue()"
    ></rr-icon>
    <div class="submenue">
      <div class="item" (click)="priorizeClick(pin)">{{ priorized ? "Deprioritize" : "Prioritize"}}</div>
      <div class="item" (click)="edit.emit(pin)">Rephrase</div>
      <rr-divider></rr-divider>
      <div class="item" (click)="delete.emit(pin)">Delete</div>
    </div>
  </div>
</div>
<div class="content">{{ pin?.content || pin?.text }}</div>
<div class="row tiny gap-8">
  <rr-badge tone="brand">{{ pin?.agentName }}</rr-badge>
  <rr-badge>{{ pin?.mainTag }}</rr-badge>
</div>
